import React from 'react'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'
import styles from './Breadcrumbs.module.scss'
import A from 'components/common/A/A'
import { useRouter } from 'next/router'

export interface BreadcrumbsProps {
  path: Array<{ href?: string; text: string }>
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ path }) => {
  const router = useRouter()
  // using chakra-ui breadcrumb component for proper aria labels (accessibility)
  // Eg. BreadcrumbItem with isCurrentPage prop adds the aria-current=page to the BreadcrumbLink.
  return (
    <Breadcrumb className={styles.breadcrumb}>
      {path.map((item, index) => (
        <BreadcrumbItem
          key={index}
          isCurrentPage={router.asPath === item.href}
          isLastChild={index === path.length - 1}
        >
          <BreadcrumbLink href={item.href || ''}>{item.text}</BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  )
}

export default Breadcrumbs
